/**
 * BuildActionCard — Dashboard Build Engine data card (2026-07-28, P3 spine).
 *
 * The first "action card" of the Business OS. Once the tenant has told us what
 * data they need (Business Profile Q3), this offers to BUILD that first artifact
 * — data ingest — by kicking off the Build Engine as a Pi chat routine (operator
 * decision §11.4, "Pi routine first"). Presentation is the shared ActionCard;
 * the dock-open + seed is the shared startPiRoutine; the seed is buildIngestSeed.
 *
 * Design doc §6 + §8:
 * docs/20260728/dashboard_onboarding_design/20260728_DESIGN_DASHBOARD_TAB_ONBOARDING_BUSINESS_OS.md
 */
import { Database } from 'lucide-react';
import { useDashboardStore } from '@/stores/dashboardStore';
import { ActionCard } from './ActionCard';
import { runBuildStep, buildIngestSeed } from './buildEngine';

export function BuildActionCard() {
  const dataAnswer = useDashboardStore((s) => s.profile.data);
  const status = useDashboardStore((s) => s.buildState.data);
  const setBuildStepStatus = useDashboardStore((s) => s.setBuildStepStatus);

  // Nothing to build from until the tenant has answered the "data" question.
  if (!dataAnswer.trim()) return null;

  return (
    <ActionCard
      testId="build-action-card"
      icon={<Database className="h-5 w-5" />}
      title="Build your data"
      description="Bring the data you need into your knowledge base so your agents can use it."
      preview={dataAnswer}
      previewTestId="build-action-data-preview"
      buttonLabel="Build my data"
      buttonTestId="build-action-start"
      onAction={() => void runBuildStep('data', buildIngestSeed(dataAnswer))}
      status={status ?? 'todo'}
      onMarkDone={() => void setBuildStepStatus('data', 'done')}
      onReopen={() => void setBuildStepStatus('data', 'todo')}
    />
  );
}

export default BuildActionCard;
